import React, { useState } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../LanguageContext';

import usinaDeCima from '../assets/images/usina-de-cima.jpeg';
import usinaBaias from '../assets/images/usina-baias.jpeg';
import maq1 from '../assets/images/maq-1.jpeg';
import comer from '../assets/images/comer.jpeg';
import entradaUsina from '../assets/images/entrada-usina.jpeg';

// Container for the whole section
const Section = styled.section.attrs({ id: 'howItWorks' })`
  padding: 4rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.grayDark};
`;

// Title of the section
const Title = styled.h2`
  text-align: center;
  font-size: 2rem;
  margin-bottom: 3rem;
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.colors.greenPrimary};
`;

// Container for single step card
const StepCard = styled.div`
  background-color: ${({ theme }) => theme.colors.grayLight};
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

// Image style
const StepImage = styled.img`
  width: 100%;
  height: 360px;
  object-fit: cover;
  object-position: center;
  border-radius: 6px;
  margin-bottom: 1rem;
  user-select: none;
`;

// Step title container with number
const StepTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
`;

// Step number style
const StepNumber = styled.span`
  background-color: ${({ theme }) => theme.colors.blueLight};
  color: ${({ theme }) => theme.colors.white};
  font-weight: 700;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 1rem;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Step title
const StepTitle = styled.h3`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.blueLight};
  font-family: ${({ theme }) => theme.fonts.primary};
  margin: 0;
`;

// Step description
const StepDescription = styled.p`
  font-size: 0.95rem;
  color: ${({ theme }) => theme.colors.grayDark};
  font-family: ${({ theme }) => theme.fonts.primary};
`;

// Navigation buttons container
const NavButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-top: 1.5rem;
`;

// Button style
const NavButton = styled.button`
  background-color: ${({ theme }) => theme.colors.greenPrimary};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  padding: 0.5rem 1.5rem;
  font-weight: 600;
  border-radius: 30px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.blueLight};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.grayLight};
    cursor: not-allowed;
  }
`;

const HowItWorks = () => {
  const { translations } = useLanguage();
  const steps = translations.howItWorks.steps;
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = [
    usinaDeCima,
    usinaBaias,
    maq1,
    comer,
    entradaUsina,
  ];

  const goPrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? steps.length - 1 : prev - 1));
  };

  const goNext = () => {
    setCurrentIndex((prev) => (prev === steps.length - 1 ? 0 : prev + 1));
  };

  const currentStep = steps[currentIndex];
  const currentImage = images[currentIndex];

  return (
    <Section>
      <Title>{translations.howItWorks.title}</Title>
      <StepCard>
        <StepImage src={currentImage} alt={currentStep.title} />
        <StepTitleContainer>
          <StepNumber>{currentIndex + 1}</StepNumber>
          <StepTitle>{currentStep.title}</StepTitle>
        </StepTitleContainer>
        <StepDescription>{currentStep.description}</StepDescription>
      </StepCard>
      <NavButtons>
        <NavButton onClick={goPrev} aria-label="Previous step">Anterior</NavButton>
        <NavButton onClick={goNext} aria-label="Next step">Próximo</NavButton>
      </NavButtons>
      <p style={{ textAlign: 'center', marginTop: '2rem', fontWeight: '600', color: '#007f3c' }}>
        {translations.howItWorks.extraInfo}
      </p>
    </Section>
  );
};

export default HowItWorks;
